@if (showTopNav) {
  <app-top-navigation-toolbar
    [suppressNavMenu]="false"
    [isSideNavOpen]="isSideNavOpen"
    (toggleSideNav)="sidenav.toggle()"
    [isAlertBannerPresent]="isAlertBannerPresent"
  ></app-top-navigation-toolbar>
}
<div class="emperor-ui-app-root version">
  RUNNING APP VERSION {{ appVersion }}
</div>
<bp-sdk-root [disableToolbar]="true" enable-lifecycle-events></bp-sdk-root>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    [fixedInViewport]="true"
    [fixedTopGap]="64"
    (openedStart)="isSideNavOpen = true"
    (closedStart)="isSideNavOpen = false"
  >
    <app-navigation-menu></app-navigation-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-alert-banner></app-alert-banner>
    <div
      class="main-content"
      [style.height]="
        showTopNav ? 'calc(100% - ' + (topBarHeight$ | async) + 'px)' : '100%'
      "
      [style.top.px]="showTopNav ? (topBarHeight$ | async) : '0'"
    >
      @if (appReady$ | async) {
        <router-outlet></router-outlet>
      } @else {
        <app-loader [isFullScreen]="true"></app-loader>
      }
    </div>

    <!-- No Enrollments Warning Dialog -->
    @if (showEnrollmentsWarningDialog) {
      <app-warning-dialog
        [data]="noEnrollmentsDialogData"
        (closeDialog)="hideEnrollmentsWarning()"
        (callback)="hideEnrollmentsWarning()"
      ></app-warning-dialog>
    }
    <app-in-progress-panel></app-in-progress-panel>
  </mat-sidenav-content>
</mat-sidenav-container>
